import { CompanySalesOrderStatus } from 'src/app/core/models/sales/company-sales-order-status.type';

const SALES_ORDER_STATUS_BY_INDEX: CompanySalesOrderStatus[] = [
  'Draft',
  'Confirmed',
  'Cancelled',
  'New',
];

export function normalizeSalesOrderStatus(
  status: CompanySalesOrderStatus | number | null | undefined,
): CompanySalesOrderStatus {
  if (typeof status === 'string') {
    return SALES_ORDER_STATUS_BY_INDEX.find((candidate) => candidate === status) ?? 'Draft';
  }

  if (typeof status === 'number') {
    return SALES_ORDER_STATUS_BY_INDEX[status] ?? 'Draft';
  }

  return 'Draft';
}

export function getSalesOrderStatusLabelKey(
  status: CompanySalesOrderStatus | number | null | undefined,
): string {
  return `COMPONENTS.SALES_ORDERS.STATUSES.${normalizeSalesOrderStatus(status).toUpperCase()}`;
}
